import config from './config';

function getResourceQuotasApi(params) {
  	return Ajax.get(config.queryResourceQuota, params);	
}
function getCalculateTotalPriceApi(params) {
    return Ajax.get(config.calculateTotalPrice, params);	
}
function getCustomInfoApi(params) {
    return Ajax.get(config.getCustomInfo, params);	
}


export {
	getResourceQuotasApi,
    getCalculateTotalPriceApi,
    getCustomInfoApi
};



// WEBPACK FOOTER //
// ./src/api/common/actions.js